import { Controller } from 'stimulus';

// Reaction-metrics modal. Closes itself by emptying the turbo-frame it lives in.
export default class extends Controller {
  static targets = ['panel'];

  close() {
    const frame = this.element.closest('turbo-frame');
    if (frame) frame.innerHTML = '';
  }

  backdrop(event) {
    if (!this.panelTarget.contains(event.target)) this.close();
  }
}
